import MaterialSymbolOutline from '@/components/iconset/mso/MaterialSymbolOutline.vue';
import type { IconSet } from 'vuetify';
import { h } from 'vue';

export const mso: IconSet = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: (props) => h(MaterialSymbolOutline, props as any)
};
